// Orchestrator for rendering search results

import { initScrollTracking } from './scroll-manager.js';
import { updateSearchUI, handleEmptyResults, hideInitialSpinner } from './state-manager.js';
import { createResultCard } from './card-renderer.js';
import { lazyFetchSummaries } from './summary-handler.js';
import { prepareContainer } from './container-manager.js';
import { prepareResultsData } from './results-preparator.js';
import { coordinateRendering } from './render-coordinator.js';

let renderFulltextResultsCount = 0;

// Initialize scroll tracking (module level once)
initScrollTracking();

/**
 * Render fulltext search results
 * @param {Object} data - Search results data
 */
export async function renderFulltextResults(data) {
    renderFulltextResultsCount++;
    
    // Flag to indicate if we're appending results (infinite scroll) vs replacing
    const isAppendingResults = window.__isAppendingResults === true;
    
    try {
        const $container = $('#nav-full-text');
        const containerState = prepareContainer($container);
        
        const preparedData = await prepareResultsData(data);
        const { results, total, currentPage, itemsPerPage, linkKeys, nameKeys, hasSummaries } = preparedData;
        
        await updateSearchUI(data, total);
        
        if (results.length > 0) {
            hideInitialSpinner($container);
        }

        if (!results.length) {
            handleEmptyResults(data, $container);
            return;
        }
        
        // Create document fragment with result cards
        const frag = document.createDocumentFragment();
        results.forEach((item, idx) => {
            const el = createResultCard(item, idx, currentPage, itemsPerPage, hasSummaries);
            frag.appendChild(el);
        });
        
        // Coordinate rendering process
        await coordinateRendering({
            resultsContainerEl: containerState.resultsContainerEl,
            frag,
            $allExistingResults: containerState.$allExistingResults,
            data,
            total,
            isAppendingResults
        });
        
        window.__isAppendingResults = false;
        lazyFetchSummaries(linkKeys, nameKeys);
        
    } catch (e) {
        console.error('[RenderResults] Error:', e);
    }
}
